module.exports = __webpack_public_path__ + "img/brady_tablet.b283d85f.png";